<script>
    import { sgettext } from '../../../i18n';
    import ElementTypeIcon from '../../Element/ElementTypeIcon.svelte';

    export let row = {};
    export let options = null;
</script>

<style>
.diff-element-name {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    padding: 0px 5px;
    display: flex;
    align-items: center;
}

.ellipsis {
    max-width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    padding: 0px 5px;
}

.contextual-blue-text {
    color: #0B6CB3;
}
</style>

<div class="diff-element-name">
    <ElementTypeIcon type={row.element.type} unstyled={true} /> 
    <span class="ellipsis" title={row.element.name}>{row.element.name}</span>
    <span class="contextual-blue-text">{row?.target?.element_instance?.suffix || row?.source?.element_instance?.suffix || ""}</span>
    {#if row.is_contextual_change}
        <div style="display: flex; flex: 1; justify-content: right">
            <span title={sgettext("$$CONTEXTUAL_CHANGES$$")} class="contextual-blue-text" style="font-size: 0.6rem; cursor: pointer;"><i class="fas fa5-circle"></i></span>
        </div>
    {/if}
</div>